import script from "./Resume.vue?vue&type=script&setup=true&lang=js"
export * from "./Resume.vue?vue&type=script&setup=true&lang=js"

import "./Resume.vue?vue&type=style&index=0&id=7502fd76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7502fd76"]])

export default __exports__